import api from '@/js/services/api';

export default {

    register(form) {
        return api().post(`/register`, form)
            .then(response => {
                window.location.href = `/application/profile`;
            })
    },

    saveStep1(form) {
        return api().post(`/application-step-1`, form)
    },

    saveStep2(form) {
        return api().post(`/application-step-2`, form)
    },

    saveStep3(form) {
        return api().post(`/application-step-3`, form)
    },

    saveStep4(form) {
        return api().post(`/application-step-4`, form)
    },

    saveStep5(form) {
        return api().post(`/application-step-5`, form)
    },

    saveStep6(form) {
        return api().post(`/application-step-6`, form)
    },

    saveStep7(form) {
        return api().post(`/application-step-7`, form)
    },

    saveStep8(form) {
        return api().post(`/application-step-8`, form)
    },

    saveStep9(form) {
        return api().post(`/application-step-9`, form)
    },

    saveStep10(form) {
        return api().post(`/application-step-10`, form)
    },


}
